
import { en } from './en';
import { es } from './es';
import { de } from './de';

// Export all translations
export const translations = {
  en,
  es,
  de,
};

// Export the translation types based on the English translations
export type TranslationType = typeof en;
